import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './App.css';
import './themes/dark.css';
import { I18nProvider } from './i18n/I18nContext';
// Import styles for react-grid-layout and react-resizable globally
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { registerServiceWorker } from './serviceWorkerRegistration';

// Render the root application. The root element is defined in
// public/index.html. ReactDOM.render is used instead of the React 18
// createRoot API to maintain compatibility with React 17 used by
// react-scripts.
ReactDOM.render(
  <I18nProvider>
    <App />
  </I18nProvider>,
  document.getElementById('root'),
);
registerServiceWorker();
